import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlugin1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="plugin-1, power, adapter"><path d="M19.25 14.25V6.25H4.75V14.25C4.75 16.4591 6.54086 18.25 8.75 18.25H15.25C17.4591 18.25 19.25 16.4591 19.25 14.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 18.25V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 6.25V2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 6.25V2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPlugin1;
